package com.eladfinish.bible.contest.screens.names.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextDirection
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.data.ChapterData
import com.eladfinish.bible.contest.domain.BooksRepository.bookNamesHebrew
import com.eladfinish.bible.contest.perek_str_placeholder
import com.eladfinish.bible.contest.ui.components.dialogs.BasicDialogWithTitle
import com.eladfinish.bible.contest.ui.components.dialogs.DialogNegativeButtonInColumn
import com.eladfinish.bible.contest.ui.components.verticalScrollWithScrollbar
import com.eladfinish.bible.contest.ui.text.getAnnotatedString
import com.eladfinish.bible.contest.utils.addGershaim
import com.eladfinish.bible.contest.utils.toOtiot
import dev.icerock.moko.resources.compose.localized
import dev.icerock.moko.resources.format

@Composable
fun ChapterDialog(
    chapterData: ChapterData,
    onDismiss: () -> Unit,
    withArrows: Boolean = false,
    onPreviousClick: () -> Unit = {},
    onNextClick: () -> Unit = {},
    onTitleClick: (() -> Unit)? = null,
) {
    val title = chapterData.bookIndex?.let {
        bookNamesHebrew[it] + " " + SharedRes.strings.perek_str_placeholder.format(
            chapterData.chapterIndex?.toOtiot()?.addGershaim().orEmpty()
        ).localized()
    }.orEmpty()

    BasicDialogWithTitle(
        onDismiss = onDismiss,
        title = title,
        withArrows = withArrows,
        onPreviousClick = onPreviousClick,
        onNextClick = onNextClick,
        onTitleClick = onTitleClick,
        content = {
            Column(
                modifier = Modifier
                    .weight(1f)
                    .fillMaxWidth()
                    .background(Color.White)
                    .verticalScrollWithScrollbar(),
            ) {
                SelectionContainer {
                    Text(
                        modifier = Modifier
                            .padding(top = 12.dp, bottom = 24.dp)
                            .padding(horizontal = 12.dp),
                        text = chapterData.getAnnotatedString(baseFontSize = 18.sp),
                        style = MaterialTheme.typography.bodyLarge.copy(
                            textDirection = TextDirection.Content,
                            fontSize = 18.sp,
                            color = Color.Black,
                            lineHeight = 28.sp,
                        ),
                    )
                }
            }
            DialogNegativeButtonInColumn(onClick = onDismiss)
        },
    )
}
